import {isMobile} from "@/utils/common";
import * as _ from "lodash";
import React, {useEffect, useState} from "react";
import {DragDropContext} from "react-beautiful-dnd";
import DroppableComDown from "../DroppableComDown.jsx";
import DroppableComUp from "../DroppableComUp.jsx";
import {gradient} from "@/utils/colorCacl"

export default function Drag(props) {
    const [data, setData] = useState({});
    const [aa, update] = useState({});
    const [_colors, setcolors] = useState([])
    const {info = {}, answer = {}, changeAnswer} = props;

    const historyAnswer = () => {
        try {
            if (Object.keys(answer).length > 0) {
                let answerHis = answer[info.id] || {};
                let newInfochilds = data.childs;
                newInfochilds.forEach((item) => {
                    if (answerHis[item.id]) {
                        item.options.map((item2) => {
                            console.log("item2", item);
                            if (answerHis[item.id][item2.id] === null) {
                                let findSlct = data.options.find(
                                    (item3) => item2.codeValue == item3.codeValue
                                );
                                item.codeValue2 = item2.codeValue;
                                if (findSlct.selctData) {
                                    findSlct.selctData = [...findSlct.selctData, item];
                                } else {
                                    findSlct.selctData = [item];
                                }
                            }
                        });
                    }
                });

                console.log("answerHis", answerHis, newInfochilds);
                let newList = newInfochilds.filter((item) => {
                    console.log("item", item.id, answerHis);
                    if (!answerHis[item.id]) {
                        return item;
                    }
                });
                data.childs = newList;
                // setData(props.info);
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        props.info.childs.map((item) => {
            item.selctData = [];
        });
        // setPostData(answer);
        // props.info.childs = infoChilds;
        setData(JSON.parse(JSON.stringify(props.info)));
    }, []);
    useEffect(() => {
        historyAnswer();
    }, [answer]);
    useEffect(() => {
        setcolors(gradient("#010000", "#dc2f20", data?.options?.filter((item) => {
            return item?.hide !== 1;
        }).length || 1))
    }, [data])
    const arrMove = (array, first, second) => {
        var tmp = array[second];
        array[second] = array[first];
        array[first] = tmp;
        return array;
    };

    // 同一个区域托 j交换
    const sameDrag = (result) => {
        const {source, destination} = result;

        let idList = data.options.map((item) => item.id);
        if (
            idList.includes(destination.droppableId) &&
            idList.includes(source.droppableId)
        ) {
            // sameDragDown(result);
        } else {
            data.childs = arrMove(data.childs, source.index, destination.index);
        }
    };

    const commitData = (data1) => {
        // const obj = { ...answer[data1.id] };
        let postList = [];
        data.options.forEach((item1) => {
            if (item1.selctData) {
                postList = [...postList, ...item1.selctData];
            }
        });
        let obj = {};
        postList.map((item1) => {
            let as = item1.options.find(
                (item2) => item2.codeValue == item1.codeValue2
            );
            obj[item1.id] = {[as.id]: null};
        });

        changeAnswer(obj);
    };
    const onBeforeDragStart = (ee) => {
        console.log("onBeforeDragStart", ee);
        sessionStorage.setItem("draggableId", ee.draggableId);
        // update(Math.random());
        /*...*/
    };
    const onDragEnd = (result) => {
        // source移动   ==》 destination 目标
        const {source, destination} = result;
        if (!destination) {
            return;
        }
        //   options 作为选项
        if (source.droppableId === destination.droppableId) {
            sameDrag(result);
        } else {
            let optionslist = data.options.find(
                (item) => item.id == source.droppableId
            );
            // 上下移动 optionslist 标识
            if (optionslist) {
                let idList = data.options.map((item) => item.id);
                if (
                    idList.includes(destination.droppableId) &&
                    idList.includes(source.droppableId)
                ) {
                    const move = data.options.find(
                        (item) => item.id == source.droppableId
                    );
                    const moveto = data.options.find(
                        (item) => item.id == destination.droppableId
                    );
                    const objc = move.selctData.splice(source.index, 1)[0];
                    objc.codeValue2 = moveto.codeValue;
                    if (!moveto.selctData || moveto.selctData.length == 0) {
                        moveto.selctData = [objc];
                    } else {
                        moveto.selctData.splice(destination.index, 0, objc);
                    }
                } else {
                    /// 下面 移动到上面区域 相互移动
                    let findObj = optionslist.selctData.splice(source.index, 1)[0];
                    data.childs.splice(destination.index, 0, findObj);
                }
            } else {
                /// 是不是多选  不做移除
                let findSourceObj = data.childs.splice([source.index], 1)[0];
                data.options.map((item) => {
                    if (item.id == destination.droppableId) {
                        findSourceObj.codeValue2 = item.codeValue;
                        if (!item.selctData) {
                            item.selctData = [findSourceObj];
                        } else {
                            item.selctData.splice(destination.index, 0, findSourceObj);
                        }
                    }
                });
            }
        }
        commitData(data);
    };

    const [eleWidth,setEleWidth] = useState(null);
    const [arrMaxLength,setArrMaxLength] = useState(1);
    const [itemMaxWidth,setItemMaxWidth] = useState("");
    const titleTbleInvisiable = (options,id) => {
        let _options = [];
        if (options) {
            _options = options.filter((item) => {
                return item.hide !== 1;
            });
        }
        return (
            <div id={`titleTbleReference-${id}`} style={{display: "flex", background: "#ccc",position:'absolute',width:eleWidth||"100px",visibility:'hidden'}}>
                {(_options || []).map((item1, index) => (
                    <div
                        key={item1?.id}
                        style={{
                            border: "1px solid #ccc",
                            background: "rgb(204, 204, 204)",
                            borderRight: "1px solid #fff",
                            textAlign: "center",
                            flex:1
                        }}
                    >
                        <div dangerouslySetInnerHTML={{__html: imgSetStyle(item1?.description)}}></div>
                        {/* 下面块区域 */}
                    </div>
                ))}
            </div>
        );
    };
    const imgSetStyle=(htmlText)=>{
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        // 查找 <img> 标签并修改属性
        const img = doc.querySelector('img');
        if (img) {
            img.setAttribute('width','none')
            img.setAttribute('height','none')
            img.setAttribute('style', 'max-width: 100%;object-fit: contain;max-height:60px;height:100%'); // 修改样式
        }
        return doc.body.innerHTML
    }
    useEffect(()=>{
        if (!(info.preferences?.childPrefer?.optionForm === 6||info.preferences?.childPrefer?.optionForm ===5)){
            return
        }
        let ele=document.getElementById("titleTbleWidthReference")
        const observer = new ResizeObserver(() => {
            // 更新元素高度
            setEleWidth(ele.offsetWidth+'px');
        });

        // 开始观察元素
        observer.observe(ele);

        // 清理函数：在组件卸载时停止观察
        return () => {
            observer.disconnect();
        };


    },[])
    useEffect(()=>{
        let temparr = [data.options];
        if (col && isMobile) {
            temparr = _.chunk(data.options || [], +col);

        }
        setArrMaxLength(Math.max(...temparr.map(item=>(item||[]).length))||1)
    },[data.options])
    useEffect(()=>{
        setItemMaxWidth((((((eleWidth?eleWidth.replace("px",""):100)||100)/(arrMaxLength||1))||100)-33)+'px')
        console.log("width:"+itemMaxWidth)
    },[eleWidth,arrMaxLength])

    const col = info.preferences?.optionPrefer?.optionsColumns;
    let arr = [data.options];

    let _colorsIndex = 0

    if (col && isMobile) {
        arr = _.chunk(data.options || [], +col);

    }

    let paishu=0

    return (
        <DragDropContext
            onDragEnd={onDragEnd}
            onBeforeDragStart={onBeforeDragStart}
        >
            {/* 上面拖拖动区域 */}
            <DroppableComUp direction={0} item1={data} update={update}/>
            <div style={{width: '100%'}} id="titleTbleWidthReference"></div>
            {arr.map((data) => {
                paishu++;
                let _data;
                if (data) {
                    _data = data.filter((item) => {
                        return item.hide !== 1;
                    });
                }
                return (
                    <>
                        {/*{info.preferences?.childPrefer?.optionForm == 5 && titleTble(_data)}*/}
                        {(info.preferences?.childPrefer?.optionForm === 6||info.preferences?.childPrefer?.optionForm ===5)&&titleTbleInvisiable(data || [], paishu)}
                        <div style={{display: 'flex', alignItems: 'stretch'}}>
                            <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
                                <div style={{display: "flex", flex: 'auto'}}>
                                    {/* 中间头信息移动至每个框上方以适应换行 */}
                                    {(_data || []).map((item1, index) => (
                                        <div style={
                                            {
                                                flexWrap: "wrap",
                                                flexDirection: "column",
                                                flex: 1,
                                                display: 'flex'
                                            }
                                        }>
                                            <div
                                                style={info.preferences?.childPrefer?.optionForm == 6 ? {backgroundImage: `linear-gradient(to right,${_colors[_colorsIndex]},${_colors[++_colorsIndex]})`,} : {display: 'none'}}>
                                                &nbsp;
                                            </div>
                                            <DroppableComDown direction={0} item1={item1}
                                                              optionForm={info.preferences?.childPrefer?.optionForm}
                                                              titleTbleData={data[index]} col={paishu}
                                                              maxItemHeight={itemMaxWidth}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/*{info.preferences?.childPrefer?.optionForm == 6 && titleTble(_data)}*/}
                    </>
                );
            })}
        </DragDropContext>
    );
}
